/**
 * Trim the uid to keep the ticker only
 */

export default function trim_uid (uid) {
  if (!uid) uid = ''
  if (!uid.includes(':')) return uid
  const parts = /.*:(.*)/.exec(uid)
  return parts[1]
}
